import * as UI from "@iyk/music-ui"
import * as React from "react"
import { ShellContext } from "./ShellContext"

const Root = ({ children, hasHeader = true }: ShellRoot.Root.Props) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)

  return (
    <ShellContext.Provider value={{ isMenuOpen, setIsMenuOpen }}>
      <div
        className={classForRoot({ hasHeader })}
        style={{
          gridTemplateAreas: hasHeader ? `"header header header" "left main right"` : `"left main right"`
        }}
      >
        {children}
        {hasHeader && <ContentRoundedCorners />}
      </div>
    </ShellContext.Provider>
  )
}
const classForRoot = UI.cva(
  [
    "min-h-dvh max-w-[100vw] sm:grid flex flex-col",
    "grid-cols-1 sm:grid-cols-[1fr_minmax(0,var(--app-content-max-width))_1fr]"
  ],
  {
    variants: {
      hasHeader: {
        false: "",
        true: "grid-rows-[var(--shell-header-height-mobile)_1fr] sm:grid-rows-[var(--shell-header-height-desktop)_1fr]"
      }
    }
  }
)

const Left = ({ children }: ShellRoot.Left.Props) => {
  return <div className={UI.cx(classForAside, "[grid-area:left]")}>{children}</div>
}

const Right = ({ children }: ShellRoot.Right.Props) => {
  return <div className={UI.cx(classForAside, "[grid-area:right]")}>{children}</div>
}
const classForAside = UI.cx(
  "hidden sm:flex flex-col sticky",
  "h-[calc(100dvh-var(--shell-header-height-desktop))]",
  "top-[var(--shell-header-height-desktop)]"
)

const Content = ({ children, className }: ShellRoot.Content.Props) => {
  return <main className={UI.cx(classForContent, className)}>{children}</main>
}
const classForContent = UI.cx(
  "[grid-area:main] bg-gray-1",
  "relative flex-1 size-full flex flex-col z-10 overflow-hidden",
  "sm:border-x border-gray-4"
)

const ContentRoundedCorners = () => {
  return (
    <div
      className={UI.cx(
        "hidden sm:block [grid-area:main] self-start sticky top-[var(--shell-header-height-desktop)]",
        "pointer-events-none z-20"
      )}
    >
      <div className="size-4 absolute top-0 left-0 overflow-hidden">
        <div className="absolute top-0 left-0 size-[28px] rounded-full border border-gray-4 shadow-[0_0_0_24px_var(--app-background-dark)]" />
      </div>

      <div className="size-4 absolute top-0 right-0 overflow-hidden">
        <div className="absolute top-0 right-0 size-[28px] rounded-full border border-gray-4 shadow-[0_0_0_24px_var(--app-background-dark)]" />
      </div>

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[calc(100%-31px)] border-t border-gray-4" />
    </div>
  )
}

export namespace ShellRoot {
  export namespace Root {
    export type Props = {
      children: React.ReactNode
      hasHeader?: boolean
    }
  }

  export namespace Content {
    export type Props = {
      children: React.ReactNode
      className?: string
    }
  }

  export namespace Left {
    export type Props = {
      children?: React.ReactNode
    }
  }

  export namespace Right {
    export type Props = {
      children?: React.ReactNode
    }
  }
}

export const ShellRoot = {
  Root,
  Left,
  Right,
  Content
}
